<script>
import {monthNumberToLabelI18N, monthToNumber} from "@/libs/Helpers";

export default {
  emits: ['onClickSelectMonth', 'update:modelValue'],
  name: 'MonthPicker',
  props: {
    modelValue: Number,
    disabled: {
      type: Boolean,
      default: false
    },
    propStartMonth: {type: Number, default: 1},
    propShowTitle: {type: Boolean, default: true},
  },
  data() {
    return {
      rowIndices: [0, 1, 2, 3],
      colIndices: [1, 2, 3],
    }
  },
  methods: {
    onClickSelectMonth(month) {
      let monthValue = this.monthToNumber(month);
      if (monthValue !== null) {
        this.month = monthValue;
        this.$emit('onClickSelectMonth', monthValue);
      }
    },
    monthToNumber(value) {
      return monthToNumber(value);
    },
    monthLabel(month, style = 'short') {
      return monthNumberToLabelI18N(month, this.$i18n, style);
    },
    getMonthValueByRowCol(row, col) {
      let key = `${row},${col}`;
      return this.monthNumberFromRowCol.hasOwnProperty(key) ? this.monthNumberFromRowCol[key] : null;
    }
  },
  computed: {
    month: {
      get() {
        return this.modelValue
      },
      set(value) {
        let monthValue = this.monthToNumber(value);
        if (monthValue !== null)
          this.$emit('update:modelValue', monthValue)
      }
    },
    monthNumberFromRowCol() {
      let initMonth = this.propStartMonth !== null &&
      this.propStartMonth !== undefined &&
      this.propStartMonth >= 1 &&
      this.propStartMonth <= 12 ?
          this.propStartMonth :
          1;

      let monthValues = {};
      this.rowIndices.forEach(row => {
        this.colIndices.forEach(col => {
          let key = `${row},${col}`;

          monthValues[key] = initMonth;
          initMonth++;

          if (initMonth > 12)
            initMonth = 1;
        })
      });

      return monthValues;
    },
    monthNumber() {
      return this.monthToNumber(this.month);
    },
    monthSelectedLabelLong() {
      return this.monthLabel(this.month, 'long');
    },
    rowIndicesLength() {
      return this.rowIndices.length - 1
    },
    monthIsValid() {
      let monthValue = this.monthNumber;
      return monthValue !== null;
    }
  }
}
</script>
<template>
  <div class="dropdown-center">
    <button class="btn btn-outline-dark border-dark-subtle dropdown-toggle w-100" type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            :disabled="disabled">
      <i class="bi bi-calendar-range me-2"></i>
      <div class="d-inline-block">
        <div class="fw-lighter small d-inline-block me-2" v-if="propShowTitle === true">
          {{ $t("SimulationInputs.Month") }}
        </div>
        <div class="text-capitalize d-inline-block">
          <template v-if="monthIsValid === false">{{ $t('formDataType.select') }}</template>
          <template v-else>{{ monthSelectedLabelLong }}</template>
        </div>
      </div>
    </button>
    <div class="dropdown-menu">
      <div class="row px-3" v-for="row in rowIndices">
        <div class="col text-center p-2" v-for="col in colIndices">
          <button class="btn px-3 py-2 text-capitalize"
                  :class="{
                      'btn-light btn-light-primary': month === null || (month !== null && getMonthValueByRowCol(row, col) !== month),
                      'btn-primary text-white': month !== null && getMonthValueByRowCol(row, col) === month
                    }"
                  @click="onClickSelectMonth(getMonthValueByRowCol(row, col))">
            {{ monthLabel(getMonthValueByRowCol(row, col)) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>